<template>

  <div class="container">
    <contact-detail :row-data="profile()" prefix="User Profile" />
  </div>

</template>

<script>

import ContactDetail from '@/components/tables/details/ContactDetail'

export default {
  components: {
    ContactDetail
  }
}

</script>



// WEBPACK FOOTER //
// UserProfile.vue?0a26722b